import { IconLampCharge } from '@/presentation/components/icons';
import React from 'react';
import Styles from './header-styles.scss';
import IconButton from '@/presentation/components/icon-button/icon-button';
import { useSetRecoilState } from 'recoil';
import { activitiesModeAtom } from '@/presentation/components/atoms/atoms-activities';
const TaskInfoHeader = () => {
    const setState = useSetRecoilState(activitiesModeAtom);
    return (React.createElement(IconButton, { className: Styles.wrapTask, onClick: () => setState(prev => (Object.assign(Object.assign({}, prev), { clickedTaskInfoHeader: true }))) },
        React.createElement("div", { className: Styles.icon },
            React.createElement(IconLampCharge, { color: "#00a3ff" })),
        React.createElement("div", { className: Styles.text }, "Task")));
};
export default TaskInfoHeader;
